import React from 'react';

import { FallbackProps } from '@kp/react-sdk/app-insights';

import { ErrorGeneric } from '@/components/ErrorGeneric';

export const ErrorFallback: React.FC<FallbackProps> = ({ error }) => (
  <ErrorGeneric error={error instanceof Error ? error : undefined} />
);
